export enum WellTypeList {
  none = 'none',
  exploration = 'exploration',
  appraisal = 'appraisal',
  development = 'development',
  injection = 'injection',
  multilateral = 'multilateral',
  plugAbandonment = 'plugAbandonment',
  intervention = 'intervention',
  wellTesting = 'wellTesting',
  geothermal = 'geothermal',
  water = 'water',
}
